<template>
    <div id="app">
        <v-app id="inspire">
            <v-card v-model="show" color="#FFFF99">
                <v-card-title>
                    <v-icon large left>mdi-wrench-clock</v-icon>
                    <h6>Planillas de Desempeño Proveedor Interno - Listado</h6>
                </v-card-title>
                <v-card-text class="pt-2">
                    <v-row dense>
                        <v-col cols="6" sm="6" md="3">
                            <v-text-field label="Filtro por Año" dense v-model="filtroperiodo">
                            </v-text-field>
                        </v-col>
                        <v-col cols="6" sm="6" md="3">
                            <v-btn tile color="success" @click="cargarListados()">
                                <v-icon left> mdi-magnify </v-icon>
                                Buscar
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>

            <v-data-table dense :headers="headers" :items="listado" locale="es-ar" class="elevation-1"
                :items-per-page="500" hide-default-footer>
                <template v-slot:item.estado="{ item }">
                    <v-chip :color="getColor(item.estado)">
                        {{ item.estado }}
                    </v-chip>
                </template>
                <template v-slot:item.actions="{ item }">
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <v-icon v-if="item.estado != 'Pendiente'" small color="blue" class="mr-2" v-on="on"
                                v-bind="attrs" @click.stop="verPlanilla(item)">
                                mdi-eye
                            </v-icon>
                        </template>
                        <span>ver plan</span>
                    </v-tooltip>
                    <!-- <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <v-icon v-if="item.estado == 'Pendiente'" small color="purple" class="mr-2" v-on="on"
                                v-bind="attrs" @click.stop="editarPlanilla(item)">
                                mdi-pencil
                            </v-icon>
                        </template>
                        <span>editar plan</span>
                    </v-tooltip> -->
                </template>
            </v-data-table>
            <VerPlanilla :visible="showPlanilla" :codgral="editedItem.codgral" :periodo="this.filtroperiodo"
                @close="showPlanilla = false"></VerPlanilla>
            <!-- <EditarPlanilla :visible="showEditar" :legajo="editedItem.legajo" :nombre="editedItem.nombre"
                :periodo="this.filtroperiodo" @close="showEditar = false">
            </EditarPlanilla> -->
        </v-app>
    </div>
</template>

<script>
import moment from "moment";
import axios from "../../../axios-auth";
import VerPlanilla from "../Desempenio/Informeprove.vue";
//import EditarPlanilla from "../Capacitaciones/Editar.vue";
import jsPDF from "jspdf";
import "jspdf-autotable";
export default {
    //components: { VerPlanilla, EditarPlanilla },
    components: { VerPlanilla },
    data: (vm) => ({
        editedItem: {},
        editedIndex: -1,
        filtroestado: "Todos",
        filtroperiodo: moment().subtract(1, 'Year').format("YYYY"),
        filtrogerencia: "Todos",
        listado: [],
        listadoO: [],
        periodoanterior: "",
        showPlanilla: false,
        showEditar: false,
        flag: "",
        estado: [
            { detalle: "Todos", valor: "Todos" },
            { detalle: "Pendiente", valor: "P" },
            { detalle: "Cerrado", valor: "C" },
        ],
        listadogerencia: [
            { nombre: "Todas las Gerencias", value: "" },
            { nombre: "Dirección General", value: "D" },
            { nombre: "Administración y Finanzas", value: "A" },
            { nombre: "Comercialización", value: "C" },
            { nombre: "Fabricación", value: "F" },
            { nombre: "Obras y Servicios", value: "O" },
            { nombre: "SGI", value: "S" },
            { nombre: "SSGG y Mantenimiento", value: "M" },
            { nombre: "Sucursal Bs As", value: "B" },
            { nombre: "Técnica y Desarrollo", value: "T" },
        ],
        headers: [
            {
                text: "Código",
                align: "center",
                sortable: false,
                value: "codgral",
            },
            { text: "Cliente", value: "cliente", sortable: false },
            { text: "Proveedor", value: "proveedor", sortable: false },
            { text: "Estado", value: "estado", sortable: false },
            { text: "Acciones", value: "actions", align: "center", sortable: false },
        ],
    }),
    // watch: {
    //     filtroperiodo() {
    //         if (this.filtroperiodo.length == 4)
    //             this.periodoanterior = parseInt(this.filtroperiodo) - 1;
    //     },
    // },

    computed: {
        show: {
            get() {
                // this.cargarListados();
                return this.visible;
            },
            set(value) {
                if (!value) {
                    this.$emit("close");
                }
            },
        },
    },

    methods: {

        getColor(estado) {
            if (estado == "Completo")
                return "green";
            if (estado == "Pendiente" || estado == "" || estado == null)
                return "red";
        },

        cargarListados() {
            this.vaciarModels();

            const periodo = this.filtroperiodo;
            this.periodoanterior = parseInt(this.filtroperiodo) - 1;
            let self = this;

            axios
                .get("/RRHH/ListadoDesempenioprove?", {
                    params: {
                        filtroperiodo: periodo,
                    },
                })
                .then((response) => {
                    response.data.forEach((element) => {

                        self.listado.push(element);

                    });
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        verPlanilla(item) {
            this.editedIndex = this.listado.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.showPlanilla = true;
        },
        editarPlanilla(item) {
            this.editedIndex = this.listado.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.showEditar = true;
        },

        vaciarModels() {
            this.listado = [];
            this.listadoO = [];
        },
    },
};
</script>